import { render } from "./CustomScheduleModal.vue?vue&type=template&id=055a3dec&scoped=true&ts=true"
import script from "./CustomScheduleModal.vue?vue&type=script&lang=ts"
export * from "./CustomScheduleModal.vue?vue&type=script&lang=ts"

import "./CustomScheduleModal.vue?vue&type=style&index=0&id=055a3dec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055a3dec"]])

export default __exports__